import { render, staticRenderFns } from "./numeral-strict.vue?vue&type=template&id=5474e01a&"
import script from "./numeral-strict.vue?vue&type=script&lang=js&"
export * from "./numeral-strict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports